import { render } from "./Global_Action_Prompt.vue?vue&type=template&id=065461e2"
import script from "./Global_Action_Prompt.vue?vue&type=script&lang=js"
export * from "./Global_Action_Prompt.vue?vue&type=script&lang=js"

import "./Global_Action_Prompt.vue?vue&type=style&index=0&id=065461e2&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__